import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import versionChecker from '../utils/versionCheck';

const GET_CURRENT_VERSION = gql`
  query GetCurrentVersion {
    getCurrentVersion {
      version
      buildTime
      lastUpdated
    }
  }
`;

const VersionDisplay = ({ className = '' }) => {
  // Get frontend version from server (updated version.json)
  const { data: versionData } = useQuery(GET_CURRENT_VERSION, {
    fetchPolicy: 'cache-first',
    pollInterval: 30000, // Poll every 30 seconds to get updates
  });

  // Debug logging (remove in production)
  // console.log('[VersionDisplay] versionData:', versionData);
  // console.log('[VersionDisplay] versionError:', versionError);
  // console.log('[VersionDisplay] loading:', versionLoading);

  const frontendVersion = versionData?.getCurrentVersion?.version || process.env.REACT_APP_VERSION || '1.0.0';
  const buildTime = versionData?.getCurrentVersion?.buildTime || process.env.REACT_APP_BUILD_TIME || new Date().toISOString();

  // State for showing version check status
  const [isChecking, setIsChecking] = useState(false);
  const [lastChecked, setLastChecked] = useState(null);

  // Manual version check function (for admin debugging)
  const handleManualCheck = async () => {
    setIsChecking(true);
    try {
      await versionChecker.checkNow();
      setLastChecked(new Date());
    } catch (error) {
      console.warn('Manual version check failed:', error);
    } finally {
      setIsChecking(false);
    }
  };

  // Double-click handler for manual check (hidden feature for admins)
  const handleDoubleClick = (e) => {
    if (e.detail === 2) { // Double click
      handleManualCheck();
    }
  };

  const formatTime = (date) => {
    return date ? date.toLocaleTimeString() : '';
  };

  return (
    <div className={`text-xs text-gray-500 ${className}`}>
      <span
        title={`Version: v${frontendVersion}\nBuild: ${buildTime}${lastChecked ? `\nLast checked: ${formatTime(lastChecked)}` : ''}\n\nDouble-click to check for updates`}
        onClick={handleDoubleClick}
        style={{ cursor: 'pointer', userSelect: 'none' }}
      >
        v{frontendVersion}
        {isChecking && (
          <span className="ml-1 animate-spin">🔄</span>
        )}
      </span>
    </div>
  );
};

export default VersionDisplay;
